@if (display()) {
  <div class="loader"></div>
}
